export default "__VITE_ASSET__b5f4331c__"